// we need the callback function for vidible videos available before the video loads or the onLoad event won't trigger.
function vidibleOnPlayerReady(player) {
    var $playerDiv = $(player.div);
    var $topVideos = $playerDiv.closest('.top-videos');
    var $container = $playerDiv.closest('.video-entry__content-main .embed-container, .top-media__video, .card__embed__video__container');
    var requiredHeightSync = true;

    if ($topVideos.length) {
        requiredHeightSync = false;
        $topVideos.topVideos('hookVidible', player);
    } else if ($playerDiv.hasClass('vidible-b-page-video')) {
        player.addEventListener(vidible.VIDEO_END, function(e) {
            var publishedDate = $(".vdb_player").data("published");
            var videoVertical = $(".vdb_player").data("videovertical");
            var nextVideoIndex = e.player.getNextVideoIndex();
            //if there is already a next video set on the player we let it play. When there is no next video getNextVideoIndex() returns 0 (first video)
            if(nextVideoIndex === 0){
                get_next_video(publishedDate, videoVertical);
            }
        });
    }

    if (requiredHeightSync) {
        player.addEventListener(vidible.PLAYER_READY, function(e) {
            var height = player.getPlayerContainer().offsetHeight + 18; // account for advertisement label on vidible video
            refreshVideoHeight($container, height);
        });
    }

    vidibleFixLabels(player);
}

function vidibleOnPlayerReadyLoop(player) {
    // Special report needs responsive players so the fix shouldn't be used
    if(!$(player.div).hasClass('vidible-b-page-special')) {
        player.addEventListener(vidible.PLAYER_READY, function(e) {
            refreshVideoHeight(player.getPlayerContainer().offsetHeight);
        });
    }
    player.addEventListener(vidible.VIDEO_TIMEUPDATE, function(e) {
    	if(e.data.playheadTime + 0.2 > e.data.duration) {
    		player.seekTo(0);
    	}
    });
    vidibleFixLabels(player);
}

function refreshVideoHeight(container, height) {
    //UK uses some players with fixed height and width, that setting makes the video totally unresponsive so 100% padding bottom in styles doesn't work on this case, we need to treat it differently
    $container = container;
    $container.css('padding-bottom', height);
}

function vidibleFixLabels(player) {
    player.addEventListener(vidible.PLAYER_READY, function(e) {
        var label = $('.vdb_player').data('aria-label');
        if (label) {
            $('.vdb_player').find('iframe').attr('aria-label', label);
        }
    });
}
